import Buttonbar from '../../components/ButtonBar'
import { Divider, List } from 'antd'
import useFinancialHooks from './hooks'
import Style from '../cooperation/cooperation.module.scss'
import Styles from './style.module.scss'
import { formatSplitString } from '../../tools/util'

const Financial = () => {
  const { dataSource, loading, onRefresh } = useFinancialHooks()

  return (
    <div style={{ padding: '0 10px' }}>
      <Buttonbar onRefresh={onRefresh} />
      <div className={Style.box}>
        <div className={Style.boxtitle}>
          <span>收款信息列表</span>
        </div>
        <Divider style={{ marginTop: 0 }} />
        <List
          itemLayout="horizontal"
          dataSource={dataSource}
          className={Styles['financial-list']}
          loading={loading}
          renderItem={(item, index) => (
            <List.Item>
              <div className={Styles['financial-item']}>
                <div className={Styles['financial-item-title']}>
                  收款账户{index + 1}
                </div>
                <div className={Styles['financial-item-content']}>
                  <p title={item.bankAccount}>{item.bankAccount}</p>
                  <p title={item.bankNum}>
                    {formatSplitString(item.bankNum, 4, ' ')}
                  </p>
                  <p title={item.bankName}>{item.bankName}</p>
                </div>
              </div>
            </List.Item>
          )}
        />
      </div>
    </div>
  )
}

export default Financial
import Buttonbar from '../../components/ButtonBar'
import { Divider, List } from 'antd'
import useFinancialHooks from './hooks'
import Style from '../cooperation/cooperation.module.scss'
import Styles from './style.module.scss'
import { formatSplitString } from '../../tools/util'

const Financial = () => {
  const { dataSource, loading, onRefresh } = useFinancialHooks()

  return (
    <div style={{ padding: '0 10px' }}>
      <Buttonbar onRefresh={onRefresh} />
      <div className={Style.box}>
        <div className={Style.boxtitle}>
          <span>收款信息列表</span>
        </div>
        <Divider style={{ marginTop: 0 }} />
        <List
          itemLayout="horizontal"
          dataSource={dataSource}
          className={Styles['financial-list']}
          loading={loading}
          renderItem={(item, index) => (
            <List.Item>
              <div className={Styles['financial-item']}>
                <div className={Styles['financial-item-title']}>
                  收款账户{index + 1}
                </div>
                <div className={Styles['financial-item-content']}>
                  <p title={item.bankAccount}>{item.bankAccount}</p>
                  <p title={item.bankNum}>
                    {formatSplitString(item.bankNum, 4, ' ')}
                  </p>
                  <p title={item.bankName}>{item.bankName}</p>
                </div>
              </div>
            </List.Item>
          )}
        />
      </div>
    </div>
  )
}

export default Financial
